export enum AppMode {
  Dev = "dev",
  Prod = "prod",
}

/*
 * Gets the app mode
 */
export function getAppMode(): AppMode {
  if (process.env.REACT_APP_MODE === "dev") {
    return AppMode.Dev;
  }
  return AppMode.Prod;
}

// Prod configs
export const API_ROOT_URL =
  getAppMode() === AppMode.Dev
    ? `${window.location.protocol}//${window.location.hostname}:5555`
    : "https://youth-camp-app-server.fly.dev";

// App Configs
export const LOGGED_IN_HOME_PAGE = "/schedule";
export const MAX_NAVBAR_WIDTH = "750px";
export const SAFE_AREA_INSET_TOP = "50px";
